import React from "react";
import "@testing-library/jest-dom";
import { fireEvent, render, screen, waitFor } from "@testing-library/react";
import { CssVarsProvider, useColorScheme } from "@mui/joy/styles";
import {
  createMaterialGridTheme,
  materialGridThemeTokens,
  useMaterialGridTheme,
} from "./materialGridTheme";

function ActiveGridTheme() {
  const theme = useMaterialGridTheme();
  const { setMode } = useColorScheme();
  return (
    <button
      type="button"
      data-testid="grid-mode"
      onClick={() => setMode(theme.palette.mode === "dark" ? "light" : "dark")}
    >
      {theme.palette.mode}
    </button>
  );
}

describe("materialGridTheme", () => {
  it.each(["light", "dark"] as const)(
    "uses Joy text and surface tokens in %s mode",
    (mode) => {
      const theme = createMaterialGridTheme(mode);

      expect(theme.palette.mode).toBe(mode);
      expect(materialGridThemeTokens).toEqual({
        textPrimary: "var(--joy-palette-text-primary)",
        textSecondary: "var(--joy-palette-text-secondary)",
        backgroundBody: "var(--joy-palette-background-body)",
        backgroundSurface: "var(--joy-palette-background-surface)",
        divider: "var(--joy-palette-divider)",
      });
    },
  );

  it("tracks Joy mode changes for the Material grid theme", async () => {
    localStorage.setItem("mode", "light");
    render(
      <CssVarsProvider defaultMode="light">
        <ActiveGridTheme />
      </CssVarsProvider>,
    );

    await waitFor(() =>
      expect(screen.getByTestId("grid-mode")).toHaveTextContent("light"),
    );
    fireEvent.click(screen.getByTestId("grid-mode"));
    await waitFor(() =>
      expect(screen.getByTestId("grid-mode")).toHaveTextContent("dark"),
    );
  });
});
